var campaign = (function (c, d) {
    

    var body,
        form,
        form_id,
        config,
        successMessage;

    c.init = function () {

        body = document.querySelector('body');
        forms = body.querySelectorAll('.' + config.formSelector);
        successMessage = document.querySelector('.' + config.successSelector);
        form_id = forms[0].getAttribute('data-id');
        // successMessage.hide();

        // On form submit.
        forms.forEach(function(form) {

            console.log('hello from this');
            
            form.addEventListener('submit', function(evt){
                // Disable default form submit.
                evt.preventDefault();

                console.log('submitting');

                successMessage = form.previousSibling;
    
                form.querySelector('.sending-overlay').classList.add('active');
    
                // Get e-mail value.
                email = form.querySelector('input[type=email]').value;
    

                var formData = encodeURI(serialize(form));

                axios({
                    method: 'post',
                    url: '/sendenquiry',
                    data: formData
                })
                .then(function (response) {
                    console.log('here');
                    console.log(response);

                    if(response.data.status == 'success') {
                        form.parentElement.querySelector('.form-success').innerHTML = "Success! Thank you for subscribing!";
                        form.classList.add('hide-form');
                        form.querySelector('.sending-overlay').classList.remove('active');
                    } else {
                        console.log('error');
                        console.log(config.errorMessage)
                        form.closest('.form-success').innerHTML = "Unfortunately there has been an error. Please try again later.";
                        form.querySelector('.sending-overlay').classList.remove('active');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            });
        })
    };

    // Handle ajax response.
    c.response = function (request, form) {
        if (request.readyState === 4) {
            if (request.status === 200) {
                console.log(form.previousSibling);
                form.parentElement.querySelector('.form-success').innerHTML = "Success! Thank you for subscribing!";
                form.classList.add('hide-form');
                form.querySelector('.sending-overlay').classList.remove('active');
            } else {
                console.log('error');
                console.log(config.errorMessage)
                form.closest('.form-success').innerHTML = "Unfortunately there has been an error. Please try again later.";
                form.querySelector('.sending-overlay').classList.remove('active');
            }
        }
    };

    // Private
    config = {
        formSelector: 'js-cm-form',
        errorMessage: 'There was a problem submitting this form. Please try later.',
        successSelector: 'form-success',
    };

    return c;

}(campaign || {}, {}));

campaign.init();


function serialize(form) {
    let requestArray = [];
    form.querySelectorAll('[name]').forEach((elem) => {
        requestArray.push(elem.name + '=' + elem.value);
    });
    if (requestArray.length > 0)
        return requestArray.join('&');
    else
        return false;
}